<template>
<div class="flights">
    <div class="row">
        <div class="col-md-4">
            <h1>Flights</h1>
        </div>
        <div class="col-md-8">
            <div class="buttons" style="float:right">
                <label for="status"> With Bookings </label>
                    <label class="switch">
                    <input id="is-active" type="checkbox" v-model="tableFilters.withBookings"/>
                    <span class="switch__slider"></span>
                </label>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <div class="row p-3" v-if="!tableFilters.withBookings">
                            <div class="col-md-12" >
                                <button class="button" style="float: right;" @click="updateAllFLightTimes">Update All</button>
                            </div>
                        </div>
                        <div class="row mt-2 p-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                  <label for="" class="form-label">Flight Number</label>
                                  <input type="text"
                                    class="form-control" 
                                    name="flight_number" 
                                    id="flight_number" 
                                    placeholder="Flight Number"
                                    v-model="tableFilters.flightNumber">
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="row">
                                    <div class="col-md-12">
                                    <h6>Flight Old Departure Range</h6>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-md-6">
                                        <dateTimePicker
                                            no-label
                                            label="From Date"
                                            id="booking-start-date"
                                            format="YYYY-MM-DD"
                                            formatted="YYYY-MM-DD"
                                            v-model="tableFilters.startDate.date"
                                            :only-date="true"
                                            button-color="#ec391e"
                                            color="#ec391e"
                                            style="border: 1px solid #DFE5F9"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <dateTimePicker
                                            no-label
                                            label="To Date"
                                            id="booking-end-date"
                                            format="YYYY-MM-DD"
                                            formatted="YYYY-MM-DD"
                                            v-model="tableFilters.endDate.date"
                                            :only-date="true"
                                            button-color="#ec391e"
                                            color="#ec391e"
                                            style="border: 1px solid #DFE5F9"
                                            :min-date="tableFilters.startDate.date"
                                            />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2" style="margin-top: 30px;">
                                <button class="button" @click="applyFilters">Filter</button>
                            </div>
                        </div>
                        <hr/>
                        <div class="row">
                            <div class="col-md-12 table-responsive">
                                <table class="table table-bordered" v-if="tableFilters.withBookings">
                                    <thead>
                                        <tr>
                                            <th>Flight Number</th>
                                            <th>Old Departure Time</th>
                                            <th>Old Arrival Time</th>
                                            <th>New Departure Time</th>
                                            <th>New Arrival Time</th>
                                            <th>Old Departure Airport</th>
                                            <th>New Departure Airport</th>
                                            <th>Old Arrival Airport</th>
                                            <th>New Arrival Airport</th>
                                            <th>Bookings</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="tableData.data.length > 0 ">
                                            <tr v-for="(flight,index) in tableData.data" :key="index">
                                                <td>
                                                    <router-link :to="`/flights/edit/${flight.flight_id}`">
                                                        {{ flight.flight_number }}
                                                    </router-link>
                                                </td>
                                                <td>{{ flight.old_departure_time }}</td>
                                                <td>{{ flight.old_arrival_time }}</td>
                                                <td class="text-danger">{{ flight.new_departure_time }}</td>
                                                <td class="text-danger">{{ flight.new_arrival_time }}</td>
                                                <td>{{ flight.old_departure_airport }}</td>
                                                <td>{{ flight.new_departure_airport }}</td>
                                                <td>{{ flight.old_arrival_airport }}</td>
                                                <td>{{ flight.new_arrival_airport }}</td>
                                                <td>
                                                    <ul>
                                                        <li v-for="(booking, bIndex) in flight.has_bookings" :key="bIndex">
                                                            <router-link :to="`/bookings/edit/${booking.id}`" target="_blank">
                                                                {{ booking.booking_ref }}
                                                            </router-link>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td>
                                                    <button class="btn btn-primary btn-sm" @click="syncFlightTimes(flight.id, true)">Sync Flight Times</button>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="11" class="text-center">No records found</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                                <table class="table table-bordered" v-if="!tableFilters.withBookings">
                                    <thead>
                                        <tr>
                                            <th>Flight Number</th>
                                            <th>Old Departure Time</th>
                                            <th>Old Arrival Time</th>
                                            <th>New Departure Time</th>
                                            <th>New Arrival Time</th>
                                            <th>Old Departure Airport</th>
                                            <th>New Departure Airport</th>
                                            <th>Old Arrival Airport</th>
                                            <th>New Arrival Airport</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="tableData.data.length > 0 ">
                                            <tr v-for="(flight,index) in tableData.data" :key="index">
                                                <td>
                                                    <router-link :to="`/flights/edit/${flight.flight_id}`">
                                                        {{ flight.flight_number }}
                                                    </router-link>
                                                </td>
                                                <td>{{ flight.old_departure_time }}</td>
                                                <td>{{ flight.old_arrival_time }}</td>
                                                <td class="text-danger">{{ flight.new_departure_time }}</td>
                                                <td class="text-danger">{{ flight.new_arrival_time }}</td>
                                                <td>{{ flight.old_departure_airport }}</td>
                                                <td>{{ flight.new_departure_airport }}</td>
                                                <td>{{ flight.old_arrival_airport }}</td>
                                                <td>{{ flight.new_arrival_airport }}</td>
                                                <td>
                                                    <button 
                                                        class="btn btn-primary btn-sm" 
                                                        @click="syncFlightTimes(flight.id)">
                                                        Sync Flight Times
                                                    </button>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="11" class="text-center">No records found</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- box -->
                </div>
            </div>
            <div class="row mt-3" v-if="tableData.recordsFiltered > 0">
                <div class="col-md-6">
                    <div class="dataTables_info">
                        Showing {{ ((tableData.draw - 1) * tableData.perPage) + 1 }} to 
                        {{ Math.min(tableData.draw * tableData.perPage, tableData.recordsFiltered) }} of 
                        {{ tableData.recordsFiltered }} entries
                        <span v-if="tableData.recordsFiltered !== tableData.recordsTotal">
                            (filtered from {{ tableData.recordsTotal }} total entries)
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <nav aria-label="Page navigation">
                        <ul class="pagination justify-content-end mb-0">
                            <li class="page-item" :class="{ disabled: tableData.draw === 1 }">
                                <a class="page-link" href="#" @click.prevent="changePage(1)">First</a>
                            </li>
                            <li class="page-item" :class="{ disabled: tableData.draw === 1 }">
                                <a class="page-link" href="#" @click.prevent="changePage(tableData.draw - 1)">Previous</a>
                            </li>
                            
                            <li class="page-item" 
                                v-for="page in visiblePages" 
                                :key="page"
                                :class="{ active: page === tableData.draw }">
                                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                            </li>
                            
                            <li class="page-item" :class="{ disabled: tableData.draw === totalPages }">
                                <a class="page-link" href="#" @click.prevent="changePage(tableData.draw + 1)">Next</a>
                            </li>
                            <li class="page-item" :class="{ disabled: tableData.draw === totalPages }">
                                <a class="page-link" href="#" @click.prevent="changePage(totalPages)">Last</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <!-- Flight Changes Intimation Modal -->
            <div class="flight-modal" v-if="showIntimationModal == true">
                <div class="flight-modal__content">
                    <div class="flight-modal__header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                            </svg>
                        </div>
                        <h3 class="flight-modal__title">
                            Flight Change Detected
                        </h3>
                        <button type="button" class="flight-modal__close" v-on:click="showIntimationModal = false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    
                    <div class="flight-modal__body">
                        <div class="alert-notice">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                            </svg>
                            <span>The following bookings have departure/arrival flight changes</span>
                        </div>

                        <div class="bookings-container">
                            <div 
                                class="booking-card" 
                                v-for="(booking, bIndex) in intimationBookingAssociatedFlights" 
                                :key="bIndex">
                                <div class="booking-card__header">
                                    <div class="booking-ref">
                                        <span class="label">Booking Reference:</span>
                                        <span class="value">{{ booking.booking_reference }}</span>
                                    </div>
                                </div>
                                
                                <div class="flights-list">
                                    <div 
                                        class="flight-change-item" 
                                        v-for="(flight, fIndex) in booking.associated_flight_changes" 
                                        :key="fIndex">
                                        <div class="flight-number-badge">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
                                            </svg>
                                            Flight {{ flight.flight_number }}
                                        </div>
                                        
                                        <div class="change-grid">
                                            <div class="change-section">
                                                <div class="section-title">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <polyline points="12 6 12 12 16 14"></polyline>
                                                    </svg>
                                                    Departure
                                                </div>
                                                <div class="change-row">
                                                    <div class="change-item old">
                                                        <span class="change-label">Previous:</span>
                                                        <span class="change-value">{{ flight.old_departure_time }}</span>
                                                    </div>
                                                    <div class="arrow-icon">→</div>
                                                    <div class="change-item new">
                                                        <span class="change-label">Updated:</span>
                                                        <span class="change-value highlight">{{ flight.new_departure_time }}</span>
                                                    </div>
                                                </div>
                                                <div class="change-row airport-row">
                                                    <div class="change-item old">
                                                        <span class="change-label">Airport:</span>
                                                        <span class="change-value">{{ flight.old_departure_airport }}</span>
                                                    </div>
                                                    <div class="arrow-icon">→</div>
                                                    <div class="change-item new">
                                                        <span class="change-label">Airport:</span>
                                                        <span class="change-value" :class="{ 'highlight': flight.old_departure_airport !== flight.new_departure_airport }">{{ flight.new_departure_airport }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="change-section">
                                                <div class="section-title">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <polyline points="12 6 12 12 16 14"></polyline>
                                                    </svg>
                                                    Arrival
                                                </div>
                                                <div class="change-row">
                                                    <div class="change-item old">
                                                        <span class="change-label">Previous:</span>
                                                        <span class="change-value">{{ flight.old_arrival_time }}</span>
                                                    </div>
                                                    <div class="arrow-icon">→</div>
                                                    <div class="change-item new">
                                                        <span class="change-label">Updated:</span>
                                                        <span class="change-value highlight">{{ flight.new_arrival_time }}</span>
                                                    </div>
                                                </div>
                                                <div class="change-row airport-row">
                                                    <div class="change-item old">
                                                        <span class="change-label">Airport:</span>
                                                        <span class="change-value">{{ flight.old_arrival_airport }}</span>
                                                    </div>
                                                    <div class="arrow-icon">→</div>
                                                    <div class="change-item new">
                                                        <span class="change-label">Airport:</span>
                                                        <span class="change-value" :class="{ 'highlight': flight.old_arrival_airport !== flight.new_arrival_airport }">{{ flight.new_arrival_airport }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="confirmation-box">
                            <div class="confirmation-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                            </div>
                            <div class="confirmation-content">
                                <h4 class="confirmation-title">Update Associated Bookings?</h4>
                                <p class="confirmation-text">
                                    By proceeding, all flight times for the associated bookings will be updated automatically. 
                                    A single email will be sent to the customers related to the flight changes if any booking have both the flight times updated.
                                </p>
                            </div>
                        </div>

                        <div class="email-template-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="email-template-label">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                            <polyline points="22,6 12,13 2,6"></polyline>
                                        </svg>
                                        Select Email Template
                                    </label>
                                    <select 
                                        id="email_template"
                                        class="email-template-select" 
                                        v-model="selectedEmailTemplate"
                                        :class="{ 'error': emailTemplateError }">
                                        <option value="">Choose an email template...</option>
                                        <option 
                                            v-for="(template, key) in emailTemplates" 
                                            :key="key" 
                                            :value="template.template_id">
                                            {{ template.template_name }}
                                        </option>
                                    </select>
                                    <span v-if="emailTemplateError" class="error-message">
                                        Please select an email template to notify customers
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <p>Please Pick the changes if any, we have done in the booking</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <template v-for="item in bookingChangeReasons">
                                                    <div class="col-md-4" :key="item.value">
                                                        <div class="form-check">
                                                        <label class="form-check-label">
                                                            <input type="checkbox" class="form-check-input" :value="item.value" v-model="selectedChangeReasons">
                                                            {{ item.value }}
                                                        </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="flight-modal__footer">
                        <button type="button" class="btn-cancel" v-on:click="showIntimationModal = false">
                            Cancel
                        </button>
                        <button type="button" class="btn-secondary" v-on:click="confirmFlightUpdateWithNotification(false)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                                <line x1="12" y1="2" x2="12" y2="12"></line>
                            </svg>
                            Continue Without Notifying
                        </button>
                        <button type="button" class="btn-confirm" v-on:click="confirmFlightUpdateWithNotification(true)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            Confirm & Notify Customer
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal__bg" v-if="showIntimationModal == true"></div>
            <!-- Flight Changes Intimation Modal -->
        </div>
    </div>
</div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import moment from 'moment'

export default {
    name: 'FlightSyncIndex',
    components: {
        VdtnetTable
    },
    watch: {
        'tableFilters.withBookings'(newVal, oldVal) {
            if (newVal !== oldVal){
                this.fetchData();
            }
        }
    },
    data() {
        return {
            tableFilters: {
                withBookings:true,
                flightNumber: '',
                startDate: {},
                endDate: {},
            },
            tableData:{
                draw: 1,
                perPage: 25,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
            },
            showIntimationModal: false,
            intimationBookingAssociatedFlights: [],
            currentFlightTrackingID: null,
            emailTemplates:[],
            bookingChangeReasons:[],
            selectedEmailTemplate: '',
            selectedChangeReasons: [],
            emailTemplateError: false

        }
    },   
    computed: {
        totalPages() {
            return Math.ceil(this.tableData.recordsFiltered / this.tableData.perPage);
        },
        visiblePages() {
            const current = this.tableData.draw;
            const total = this.totalPages;
            const delta = 2; // Number of pages to show on each side of current page
            const pages = [];
            
            // Always show first page
            if (current > delta + 2) {
                pages.push(1);
                if (current > delta + 3) {
                    pages.push('...');
                }
            }
            
            // Show pages around current page
            for (let i = Math.max(1, current - delta); i <= Math.min(total, current + delta); i++) {
                pages.push(i);
            }
            
            // Always show last page
            if (current < total - delta - 1) {
                if (current < total - delta - 2) {
                    pages.push('...');
                }
                pages.push(total);
            }
            
            return pages;
        }
    }, 
    mounted(){
        this.fetchData();
    },    
    methods : {
        changePage(page) {
            if (page === '...' || page < 1 || page > this.totalPages) {
                return;
            }
            this.tableData.draw = page;
            this.fetchData();
        },
        applyFilters(){
            this.tableData.draw = 1;
            this.fetchData();
        },
        fetchData(){
            let vm = this;
            this.$store.dispatch('setLoadStatus')
            fetch(`${vm.$api}flights/time-changes/change-data`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    start: vm.tableData.draw,
                    length: vm.tableData.perPage,
                    filters: vm.tableFilters
                })
            })
            .then(response => response.json())
            .then(res => {
                this.$store.dispatch('setLoadStatus')
                console.log(res);
                if(res.status){
                    vm.tableData = res.data;
                    vm.emailTemplates = res.emailTemplates;
                    vm.bookingChangeReasons = res.booking_change_reasons;
                }
                
            });
        },
        syncFlightTimes(flightTrackingID, checkForBooking) {
            if(checkForBooking) {
                // Here We will first check for the Flight Bookings if there's any other change for the deaprture/arrival time or airport
                // Step 1: Get The Associated Bookings for the Flight Change ID
                let vm = this;
                let associatedBookings = vm.tableData.data.find(flight => flight.id === flightTrackingID).has_bookings;
                if(associatedBookings.length > 0){
                    let bookingIds = associatedBookings.map(booking => booking.id);
                    console.log(bookingIds);
                    this.checkFlightAssociatedBookings(flightTrackingID, bookingIds);
                }
            }else{
                // Here We will directly sync the flight times and airport changes
                this.updatFlightTimes(flightTrackingID);
            }
        },
        checkFlightAssociatedBookings(flightTrackingID, bookingsIDs) {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}flights/time-changes/check-change-flight-bookings`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    flight_change_id: flightTrackingID,
                    booking_ids: bookingsIDs
                })
            })
            .then(response => response.json())
            .then(res => {
                this.$store.dispatch('setLoadStatus')
                if (res.status) {
                    this.showIntimationModal = res.haveAnotherChangeBooking
                    this.intimationBookingAssociatedFlights = res.data
                    this.currentFlightTrackingID = res.flight_change_id
                    this.selectedEmailTemplate = ''
                    this.emailTemplateError = false
                }
            });
        },
        confirmFlightUpdateWithNotification(notifyCustomers) {
            if (!this.selectedEmailTemplate) {
                this.emailTemplateError = true;
                this.$notify({
                    type: 'error',
                    title: 'Please select an email template to notify customers'
                });
                return;
            }else{
                this.emailTemplateError = false;
                this.updatFlightTimes(this.currentFlightTrackingID, this.intimationBookingAssociatedFlights, true, notifyCustomers);
            }
        },
        updatFlightTimes(flightTrackingID, associatedBookings = [], sendNotification=false, notifyCustomers=false) {
            let vm = this;
            vm.$store.dispatch('setLoadStatus')
            fetch(`${vm.$api}flights/time-changes/update-direct-flight-change`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    flight_change_id: flightTrackingID,
                    associatedBookings: associatedBookings || [],
                    sendNotification : (sendNotification) ? 'yes' : 'no',
                    notifyCustomers : (notifyCustomers) ? 'yes' : 'no',
                    selectedReasons: this.selectedChangeReasons,
                    emailTemplate: this.selectedEmailTemplate
                })
            })
            .then(response => response.json())
            .then(res => {
                vm.$store.dispatch('setLoadStatus')
                if(res.status){
                    vm.$notify({
                        type: 'success',
                        title: res.message
                    });
                    vm.showIntimationModal = false;
                    vm.fetchData();
                }else{
                    vm.$notify({
                        type: 'error',
                        title: res.message
                    });
                }
            });
        },
        updateAllFLightTimes(){
            this.$swal.fire({
                title: 'Are you sure?',
                text: "This will sync all flight time changes. This action cannot be undone.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update all!'
            }).then((result) => {
                if (result.isConfirmed) {
                    let vm = this;
                    this.$store.dispatch('setLoadStatus')
                    fetch(`${vm.$api}flights/time-changes/update-all-flight-changes`,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then(response => response.json())
                    .then(res => {
                        this.$store.dispatch('setLoadStatus')
                        if(res.status){
                            this.$notify({
                                type: 'success',
                                title: res.message
                            });
                            vm.fetchData();
                        }else{
                            this.$notify({
                                type: 'error',
                                title: res.message
                            });
                        }
                    });
                }
            });
        }
    }
}

</script>
<style scoped>
.heartbeat {
  animation: heartbeat 1.2s infinite;
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    transform: scale(1.2);
    opacity: 0.6;
  }
  40% {
    transform: scale(0.95);
    opacity: 1;
  }
  60% {
    transform: scale(1.15);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Modern Modal Styles */
.flight-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
  overflow-y: auto;
}

.flight-modal__content {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.flight-modal__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 28px 32px;
  border-radius: 16px 16px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flight-modal__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  flex: 1;
  letter-spacing: -0.5px;
}

.flight-modal__close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: white;
}

.flight-modal__close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.flight-modal__body {
  padding: 32px;
  overflow-y: auto;
  flex: 1;
}

.alert-notice {
  background: #e3f2fd;
  border-left: 4px solid #2196F3;
  padding: 16px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  color: #1565c0;
  font-size: 14px;
  font-weight: 500;
}

.alert-notice svg {
  flex-shrink: 0;
}

.bookings-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.booking-card {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.booking-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.booking-card__header {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.booking-ref {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: 600;
  font-size: 15px;
}

.booking-ref .label {
  opacity: 0.9;
}

.booking-ref .value {
  background: rgb(254 2 2 / 68%);;
  padding: 4px 12px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
}

.flights-list {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.flight-change-item {
  background: white;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #e9ecef;
}

.flight-number-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 16px;
}

.change-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 768px) {
  .change-grid {
    grid-template-columns: 1fr;
  }
}

.change-section {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 13px;
  color: #495057;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.change-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.change-row:last-child {
  margin-bottom: 0;
}

.airport-row {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px dashed #dee2e6;
}

.change-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.change-label {
  font-size: 11px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.change-value {
  font-size: 13px;
  font-weight: 600;
  color: #212529;
  font-family: 'Courier New', monospace;
}

.change-value.highlight {
  color: #dc3545;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.arrow-icon {
  color: #6c757d;
  font-size: 16px;
  font-weight: bold;
  flex-shrink: 0;
}

.confirmation-box {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.confirmation-icon {
  background: white;
  padding: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  flex-shrink: 0;
}

.confirmation-content {
  flex: 1;
}

.confirmation-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.confirmation-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
}

.flight-modal__footer {
  padding: 20px 32px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f8f9fa;
  border-radius: 0 0 16px 16px;
}

.btn-cancel, .btn-confirm {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-cancel {
  background: white;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.btn-cancel:hover {
  background: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-confirm {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
}
.btn-confirm:active {
  transform: translateY(0);
}

.btn-secondary {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(240, 147, 251, 0.5);
}

.btn-secondary:active {
  transform: translateY(0);
}

/* Email Template Selection Styles */
.email-template-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid #e9ecef;
}

.email-template-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 12px;
}

.email-template-label svg {
  color: #667eea;
}

.email-template-select {
  width: 100%;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  color: #020202;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.email-template-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.email-template-select:hover {
  border-color: #667eea;
}

.email-template-select.error {
  border-color: #dc3545;
  animation: shake 0.3s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.error-message {
  display: block;
  color: #dc3545;
  font-size: 12px;
  margin-top: 8px;
  font-weight: 500;
}

.email-template-select option {
  padding: 10px;
}

.email-template-select option:first-child {
  color: #6c757d;
}

</style>